namespace $.$$ {
	$mol_style_define($bog_formigo_settings, {
		Body_content: {
			padding: $mol_gap.block,
			gap: '1.5rem',
		},

		Auth_warning: {
			color: $mol_theme.special,
			font: {
				size: '.85rem',
			},
		},

		Auth_key: {
			font: {
				family: 'monospace',
				size: '.75rem',
			},
			padding: $mol_gap.text,
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
		},
	})
}
